import request from "@/utils/http/requset";

function getPayOutList(data) {
  return request({
    url: "/manage/payout/search",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}
function getPayOutSearchDownload(data) {
  return request({
    url: "/manage/payout/search/download",
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Accept": "application/json, text/plain, */*"
    },
    data: data,
    responseType: "blob",
    timeout: 30000
  });
}
export default {
  getPayOutList,
  getPayOutSearchDownload,
};
